window.renderBool2 = (val) => {
    return '' + '<div style="text-align:center;height: 18px;width: 18px;overflow:visible;display: block;margin-right: auto;margin-left: auto;"' + (val ? ' class="x-form-cb-checked"' : "") + '> <div class="x-form-checkbox-default"/>' + '</div>';
};

window.renderBool3 = (val) => {
    return '' + '<div class="iconDivColValueRenderBool' + (val ? " x-form-cb-checked" : "") + '"> <div class="x-form-checkbox-default"/>' + '</div>';
};

window.renderBool4 = (val) => {
    return '' + '<span class="iconDivColValueRenderBool mobile' + (val ? " x-form-cb-checked" : "") + '"> <span class="x-form-checkbox-default"/>' + '</span>';
};

window.renderBoolIsSerwisant = (val) => {
    var res = val == 0 ? true : false;
    return '' + '<div class="iconDivColValueRenderBool' + (res ? " x-form-cb-checked" : "") + '"> <div class="x-form-checkbox-default"/>' + '</div>';
};

window.isValidOperatorFirmaLimit = () => {
    return (AppOPERATORFIRMA != null && !Const.CLOUDFLAG)
}

window.isValidOperatorFirmaRaw = () => {
    return (AppOPERATORFIRMA != null)
}

window.validPrivilegesOperatorComplex = (accessNameRecordOpFull) => {
    return AppOPERATOR.privileges[accessNameRecordOpFull] == null ? false : AppOPERATOR.privileges[accessNameRecordOpFull];
}

window.checkIfHttpsRenderCzytnikFixBtn = () => {
    if (window.location.protocol == 'https:') {
        return `${Lang.czytnik_brak_polaczenia_z_usluga}<button
            onclick="Ext.create('WindowCzytnikCertPanel').showW();">${Lang.rozwiazywanie_problemow}</button>`
    } else {
        return Lang.czytnik_brak_polaczenia_z_usluga
    }
};

window.notEmptyAfterTrim = function (v) {
    return v && v.length && v.trim && v.trim().length > 0
};

window.resolveHtmlDocumentType = function () {
    if (Const.ENTERPRISEFLAG) {
        return "_ent"
    } else if (Const.SKPFLAG) {
        return "_skp"
    } else if (Const.OPTIMALFLAG) {
        return "_opt"
    } else if (Const.STARTERFLAG) {
        return "_starter"
    } else if (Const.BASICFLAG) {
        return "_basic"
    } else if (Const.STANDARDFLAG) {
        return "_std"
    } else if (Const.PROFLAG) {
        return "_pro"
    } else return ""
};

window.resolveHtmlDocumentLang = function () {
    if (Const.CURRENTLANG == "pl") {
        return "_pl"
    } else return "_en"
};
